import { CrewOption } from './types';

export const sortPinnedFirst = (options: CrewOption[], pinnedValues: string[]) => {
  if (!pinnedValues.length) return options;

  return [
    ...options.filter((el) => pinnedValues.includes(el.value)),
    ...options.filter((el) => !pinnedValues.includes(el.value)),
  ];
};

export const filterOptions = (options: CrewOption[], search: string) => {
  const query = search.trim().toLocaleLowerCase();
  if (!query) return options;

  return options.filter(
    (el) =>
      el.label.toLocaleLowerCase().includes(query) ||
      el.sublabel?.toLocaleLowerCase().includes(query),
  );
};
